import { render, staticRenderFns } from "./AlbumMain.vue?vue&type=template&id=70feb943&scoped=true&"
import script from "./AlbumMain.vue?vue&type=script&lang=js&"
export * from "./AlbumMain.vue?vue&type=script&lang=js&"
import style0 from "./AlbumMain.vue?vue&type=style&index=0&id=70feb943&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70feb943",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70feb943')) {
      api.createRecord('70feb943', component.options)
    } else {
      api.reload('70feb943', component.options)
    }
    module.hot.accept("./AlbumMain.vue?vue&type=template&id=70feb943&scoped=true&", function () {
      api.rerender('70feb943', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Organizers/Album/AlbumMain.vue"
export default component.exports